module.exports = __webpack_public_path__ + "assets/logo.0a04819b.svg";